(() => {
  if (window.xoticFooterInitialized) return;
  window.xoticFooterInitialized = true;

  const selector = '[data-xp-footer]';
  const states = new WeakMap();
  const mobile = window.matchMedia('(max-width: 599px)');

  function initialize(footer) {
    if (states.has(footer)) return;
    const controller = new AbortController();
    const menus = Array.from(footer.querySelectorAll('[data-footer-menu]'));
    const syncMenus = () => menus.forEach((menu) => {
      menu.open = !mobile.matches;
      const summary = menu.querySelector('summary');
      if (mobile.matches) {
        summary?.removeAttribute('tabindex');
        summary?.removeAttribute('aria-disabled');
      } else {
        summary?.setAttribute('tabindex', '-1');
        summary?.setAttribute('aria-disabled', 'true');
      }
    });
    syncMenus();
    mobile.addEventListener('change', syncMenus, { signal: controller.signal });
    menus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (!mobile.matches && !menu.open) menu.open = true;
      }, { signal: controller.signal });
    });
    footer.querySelectorAll('.xp-localization-form').forEach((form) => {
      form.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLSelectElement)) return;
        const submit = form.querySelector('button[type="submit"]');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else if (submit) submit.click();
      }, { signal: controller.signal });
    });
    states.set(footer, controller);
  }

  function findFooters(root) {
    const footers = Array.from(root.querySelectorAll(selector));
    if (root instanceof Element && root.matches(selector)) footers.unshift(root);
    return footers;
  }

  findFooters(document).forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    findFooters(event.target).forEach(initialize);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    findFooters(event.target).forEach((footer) => {
      states.get(footer)?.abort();
      states.delete(footer);
    });
  });
})();
